import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import keycloak from './services/keycloak.js';

const keycloakProviderInitConfig = {
    enableLogging: true,
    checkLoginIframe: false,
    flow: 'standard',
    onLoad: 'check-sso',
};

createRoot(document.getElementById('root')).render(
  <ReactKeycloakProvider 
    authClient={keycloak} 
    initOptions={keycloakProviderInitConfig}
  >
    <Provider store={store}>
      <StrictMode>
        <App />
      </StrictMode>
    </Provider>
  </ReactKeycloakProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();